import { render, staticRenderFns } from "./PopupView.vue?vue&type=template&id=23318848&scoped=true&"
import script from "./PopupView.vue?vue&type=script&lang=js&"
export * from "./PopupView.vue?vue&type=script&lang=js&"
import style0 from "./PopupView.vue?vue&type=style&index=0&id=23318848&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23318848",
  null
  
)

export default component.exports